// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SCROLL UP AFTER COLLAPSE
// =RESPONSIVE VIDEO!

//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$(".msdw-page-scroll").click(function () {
  if (
    location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
    location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      var offsetValue = 0;
      if (window.innerWidth <= 767) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $("html,body").animate(
        {
          scrollTop: target.offset().top - offsetValue,
        },
        900
      );
      return false;
    }
  }
});

//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));

//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const togglers = document.querySelectorAll(".msdw-toggler");

function toggleCollapse() {
  togglers.forEach((toggler) => {
    toggler.checked = false;
  });
}

const filterNav = new Swiper("#filterNav", {
  spaceBetween: 10,
  slidesPerView: "auto",
  freeMode: true,
  // watchSlidesProgress: true,
  loop: false,
  allowTouchMove: true,
  breakpoints: {
    600: { spaceBetween: 15 },
    900: { spaceBetween: 20 },
    1200: { allowTouchMove: false },
  },
  on: {
    click: () => toggleCollapse(),
  },
});

const filterContent = new Swiper("#filterContent", {
  noSwipingClass: "no-swipe",
  slidesPerView: 1,
  spaceBetween: 0,
  effect: "fade",
  fadeEffect: { crossFade: true },
  speed: 5,
  loop: false,
  thumbs: { swiper: filterNav },

  // initialSlide: 5, // comment when done building
});

const sliderSubProducts = new Swiper("#sliderSubProducts", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  navigation: {
    prevEl: ".swiper-products-button-prev",
    nextEl: ".swiper-products-button-next",
  },
});

const sliderCarryingSystems = new Swiper("#sliderCarryingSystems", {
  slidesPerView: 1.115,
  spaceBetween: 10,
  freeMode: true,
  breakpoints: {
    600: {
      slidesPerView: 1.67,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 4,
      spaceBetween: 20,
      noSwipingClass: "msdw-no-swipe--lg",
    },
  },
});

//
// =SCROLL UP AFTER COLLAPSE
// --------------------------------------------------

togglers.forEach((toggler) => {
  toggler.addEventListener("change", function () {
    if (!this.checked) {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(this).parent().offset().top - 59,
        },
        350
      );
    }
  });
});

//
// =VIDEO POP-UP
// --------------------------------------------------

const playVideoBtns = document.querySelectorAll(".msdw-play-video");
const msdwPopupVideoWrapper = document.querySelector(
  ".msdw-popup-video-wrapper"
);
const msdwPopupVideoBackDrop = document.querySelector(
  ".msdw-popup-video-backdrop"
);
const msdwPopupVideo = document.getElementById("msdwPopupVideo");

if (document.contains(msdwPopupVideoWrapper)) {
  // OPEN
  playVideoBtns.forEach((playVideoBtn) => {
    playVideoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const videoUrl = playVideoBtn.getAttribute("data-modal-video");
      msdwPopupVideo.setAttribute("src", videoUrl);
      msdwPopupVideoWrapper.classList.add("msdw-active");
      document.body.classList.add("jws-overflowHidden");
      msdwPopupVideo.muted = false;
      msdwPopupVideo.play();
    });
  });

  // CLOSE
  const closePopUpVideo = () => {
    document.body.classList.remove("jws-overflowHidden");
    msdwPopupVideo.muted = true;
    msdwPopupVideo.pause();
    msdwPopupVideo.currentTime = 0;

    msdwPopupVideoWrapper.classList.remove("msdw-active");
  };

  msdwPopupVideoBackDrop.addEventListener("click", () => {
    closePopUpVideo();
  });

  window.onkeydown = (e) => {
    if (e.keyCode == 27) closePopUpVideo();
  };
}

//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById('msdw-video-responsive');

function loadVideo() {
  var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
      md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
      lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
      xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if      (sm.matches) { changeVideoSize('sm') }
  else if (md.matches) { changeVideoSize('md') }
  else if (lg.matches) { changeVideoSize('lg') }
  else if (xl.matches) { changeVideoSize('xl') }
}

function changeVideoSize(size){
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-"+size));
  vid.autoplay = true;
  vid.load();
  // console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener('DOMContentLoaded', loadVideo);
  window.onresize = loadVideo;
  vid.onloadeddata = () => vid.classList.add('msdw-video-loaded');
}
